export const environment = {
  production: true,
  projectName: 'Optimal Project',
  apiUrl: 'https://web-api.prod.optimaldistributiongroup.com/api/',
  rulesEngineUrl:
    'https://web-api.prod.optimaldistributiongroup.com/api/rules/',
  auth0: {
    domain: 'auth.optimaldistributiongroup.com',
    clientId: '1uveYaXoY4OW58VXk4dWyBsSOfAyw2Nf',
    redirectUri: 'https://optimaldistributiongroup.com/system',
    cacheLocation: 'memory',
  },
  mode: 'production',
  apiVersion: '2.1',
  datadog: {
    applicationId: '87527482-7fbf-40a7-b55a-f50c028a4013',
    clientToken: 'pub3f8ac3c6af5dfcdebf632e9f36719f0a',
    site: 'datadoghq.com',
    env: 'prod',
    service: 'optimalapp-spa',
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      'https://www.prod.optimaldistributiongroup.com',
      'https://prod.optimaldistributiongroup.com',
      'https://optimaldistributiongroup.com',
    ],
    enableSessionReplays: true,
  },
  featureFlags: {
    cirqueDuSoleil: false,
    accounts: false,
    workQueues: false,
    olapMode: false,
  },
};
